// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"178":"05265116","572":"2b8183b6","676":"05265116"}[chunkId] + ".css";
};